import React, { useEffect } from 'react';
import './App.css';
// Importing Providers

import { AppConfigDataContext } from './context';
import { ServicesProvider } from './apis';
import { AuthProvider } from './context/AuthContext';

import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
// Importing Routes
import AppRouter from './AppRouter';
import NavigationDrawer from './components/navigation';
import { useDispatch, useSelector } from 'react-redux';
import {
	fetchAnnouncements,
	fetchCourseList,
	fetchUserReport,
} from './redux/user/userSlice';
import {
	fetchCourseData,
	fetchMeetingIDs,
	getLeaderBoard,
	getTotalAssignmentSolved,
} from './redux/course/courseSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchAllContests } from './redux/contest/contestSlice';

function App() {
	const dispatch = useDispatch();
	const location = useLocation();
	const path = location.pathname;

	const courseState = useSelector((state: any) => state.course);
	const { courseID, courseloading } = courseState;

	const userState = useSelector((state: any) => state.user);
	const {
		latestCourseID,
		userDataStatus,
		userCourseStatus,
		user,
		courseList,
	} = userState;

	const getCreds = async () => {
		console.log('TRACKING CALLS');
		console.log('in cred call');

		if (process.env.REACT_APP_TOKEN) {
			const localToken = process.env.REACT_APP_TOKEN;
			await localStorage.setItem('acciojobs-token', localToken);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			if (jwt_decode(localToken).roles[0] === 'precourse-user') {
				window.open('https://precourse.acciojob.com', '_self');
			}
			if (user === null && path !== '/idle' && path !== '/web-idle') {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				await dispatch(fetchUserReport());
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				await dispatch(fetchCourseList());

				console.log('FROM ABOVE COUNT FETCH USER REPORT');
			}
		} else {
			const domain = '.acciojob.com';
			const localAccioToken = Cookies.get('acciojobs-token');
			if (localAccioToken) {
				await localStorage.setItem('acciojobs-token', localAccioToken);
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				if (jwt_decode(localAccioToken).roles[0] === 'precourse-user') {
					await localStorage.clear();
					await Cookies.remove('acciojobs-token', {
						domain: `.acciojob.com`,
					});
					window.open('https://auth.acciojob.com', '_self');
					console.log('logout');
				}
				if (user === null && path !== '/idle' && path !== '/web-idle') {
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					await dispatch(fetchUserReport());
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					await dispatch(fetchCourseList());
					console.log('FROM BELOW COUNT FETCH USER REPORT');
				}
			} else window.open('https://auth.acciojob.com', '_self');
		}
	};

	useEffect(() => {
		getCreds();
	}, [path]);

	useEffect(() => {
		if (courseList.length > 0 && (path === '/' || path === '/modules')) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchMeetingIDs(courseList[0].id));
		}
	}, [courseList]);

	//
	// useEffect(() => {
	// 	if (!userDataStatus || !userCourseStatus) {
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(fetchUserReport());
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		dispatch(fetchCourseList());
	// 		console.log('Hello');
	// 	}
	// }, []);

	useEffect(() => {
		if (
			courseID === null &&
			latestCourseID !== null &&
			path !== '/idle' &&
			path !== '/web-idle'
		) {
			console.log('location', location.pathname);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchCourseData());
			if (path === '/') {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(fetchAllContests());
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(getTotalAssignmentSolved());
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				dispatch(fetchAnnouncements());
			}
		}
	}, [latestCourseID, path]);

	useEffect(() => {
		if (courseID !== null && path === '/') {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(getLeaderBoard());
		}
	}, [courseID, path]);

	return (
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		<ServicesProvider>
			<AppConfigDataContext>
				<AuthProvider>
					<NavigationDrawer>
						<AppRouter />
					</NavigationDrawer>
				</AuthProvider>
			</AppConfigDataContext>
		</ServicesProvider>
	);
}

export default App;
